<template>
    <v-app class="backgroundHome">
        <v-layout row wrap>
            <v-flex d-flex>
                <v-layout justify-space-between>
                    <v-flex xs12>
                        <v-layout justify-start>
                            <img class="logoDiba" :src="logoDiba" alt="">
                        </v-layout>
                    </v-flex>
                    <br>
                    <br>
                    <br>
                    <br>
                    <v-flex xs12>
                        <v-layout justify-end column>
                            <v-flex xs12>
                                <v-layout justify-end>
                                    <v-btn round color="#FF7BA3" class="whiteText" v-on:click="toHome">
                                        <v-icon>exit_to_app</v-icon>
                                    </v-btn>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-container>
            <v-card max-widht="200px" class="cardProfile">
                <v-form>
                    <v-container>
                        <div class="personalDataProfile">

                            <v-layout>
                                <v-flex xs6 md4>
                                    <v-layout justify-center column>
                                        <v-flex xs6>
                                            <v-layout justify-center>
                                                <img class="imgUserProfileClass"
                                                     :src="imgProfile"
                                                     alt="">
                                            </v-layout>
                                        </v-flex>
                                        <v-flex>
                                            <v-layout justify-center class="textProfile">
                                                <label class="fileContainer">
                                                    <v-btn round small color="grey lighten-2" class="text-lowercase">
                                                        <i>{{ $t('changeImgProfile' )}}</i>
                                                        <input @change="uploadPhoto" type="file"/>
                                                    </v-btn>
                                                </label>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs6 md12>
                                    <v-form ref="form">
                                        <v-text-field class="textProfile"
                                                      v-model="usernameProfile"
                                                      :label=" $t('usernameProfile' )"
                                                      required
                                                      :rules="usernameRules"
                                        ></v-text-field>
                                    </v-form>
                                </v-flex>
                            </v-layout>
                            <br>
                            <v-layout>
                                <v-flex>
                                    <v-select
                                            class="textProfile"
                                            v-model="selectEntitat"
                                            :items="entitats"
                                            :label="$t('entitatProfile')"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                        </div>
                        <br>
                        <v-divider></v-divider>
                        <br>
                        <div class="personalDataProfile">
                            <v-layout>
                                <v-flex xs12>
                                    <v-layout justify-center align-center>
                                        <div class="textProfile">{{$t('scoreProfile')}}
                                            <v-layout justify-center>
                                                <h1>{{scoreProfile}}</h1>
                                            </v-layout>
                                        </div>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12>
                                    <v-layout justify-center align-center>
                                        <div class="textProfile">{{$t('positionRankingProfile')}}
                                            <v-layout justify-center>
                                                <h1>{{posicioRanking}}</h1>
                                            </v-layout>
                                        </div>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12>
                                    <v-layout justify-center align-center>
                                        <div class="textProfile">{{$t('preguntesEncertadesProfile')}}
                                            <v-layout justify-center>
                                                <h1>{{numberCorrectAnswers}}</h1>
                                            </v-layout>
                                        </div>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12>
                                    <v-layout justify-center align-center>
                                        <div class="textProfile">{{$t('preguntesFalladesProfile')}}
                                            <v-layout justify-center>
                                                <h1>{{numberFailedAnswers}}</h1>
                                            </v-layout>
                                        </div>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </div>
                        <br>
                        <v-divider></v-divider>
                        <br>
                        <div class="personalDataProfile">
                            <v-layout>
                                <v-flex xs2 md5>
                                </v-flex>
                                <v-flex>
                                    <v-layout justify-center>
                                        <v-radio-group v-model="row" row>
                                            <v-flex xs6>
                                                <img :src="padroneta" class="imgUserProfileClass">
                                                <v-radio class="textProfile" label="Padroneta" value="1"></v-radio>
                                            </v-flex>
                                            <v-flex xs6>
                                                <img :src="padronet" class="imgUserProfileClass">
                                                <v-radio class="textProfile" label="Padronet" value="2"></v-radio>
                                            </v-flex>
                                        </v-radio-group>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </div>
                        <v-layout>
                            <v-flex>
                                <v-layout justify-end>
                                    <v-btn round class="textProfile" color="cyan" outline
                                           v-on:click="saveDataProfile()">
                                        Guardar
                                    </v-btn>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card>
            {{dataProfile}}
        </v-container>
    </v-app>
</template>

<script>


    import {db} from '../firebaseConfig'
    import firebase from 'firebase';
    import logoDiba from '../img/Marca DB DO negatiu quadrat.png'

    import padronet from '../img/Logo_el_Padronet_normal.png'
    import padroneta from '../img/Logo_la_Padroneta_normal.png'

    import Noty from 'noty';

    let usersRef = db.ref('Users');
    let entitatsRef = db.ref('taulaEntitats');

    var storage = firebase.storage();

    var storageRef = storage.ref();
    import {Trans} from '../plugins/Translation'

    export default {
        name: "ProfileUser",
        data() {
            return {
                valid: false,
                logoDiba: logoDiba,
                padronet: padronet,
                padroneta: padroneta,
                uidActualUser: null,
                usernameProfile: null,
                imgProfile: null,
                scoreProfile: null,
                numberCorrectAnswers: null,
                numberFailedAnswers: null,
                counterGames: null,
                uploadValue: 0,
                row: null,
                padronetx: 0,
                entitats: [],
                selectEntitat: null,
                posicioRanking: null,
                usernameRules: [
                    v => !!v || ''
                ],
                warningUsernameEmpty: ''
            }
        },
        firebase: {
            usersRef,
            entitatsRef
        },
        created() {
            let this2 = this;
            firebase.auth().onAuthStateChanged(function (user) {
                usersRef.child(user.uid).child('padronetx')
                    .on('value', snap => this2.row = snap.val());
            });
        },
        methods: {
            saveDataProfile() {
                if (this.$refs.form.validate()) {
                    let this2 = this;
                    firebase.auth().onAuthStateChanged(function (user) {
                        usersRef.child(user.uid).child('username').set(this2.usernameProfile);
                        usersRef.child(user.uid).child('imgUser').set(this2.imgProfile);
                        usersRef.child(user.uid).child('modifyData').set(true);
                        usersRef.child(user.uid).child('padronetx').set(this2.row);
                        usersRef.child(user.uid).child('entitat').set(this2.selectEntitat);
                    });

                    new Noty({
                        layout: 'topCenter',
                        type: 'warning',
                        text: "Guardat!",
                        timeout: 2000
                    }).show();
                } else {
                    if (Trans.currentLanguage === 'cat') {
                        this.warningUsernameEmpty = "Introduiex el nom d'usuari";

                    } else if (Trans.currentLanguage === 'es') {
                        this.warningUsernameEmpty = "Introduce el nombre de usuario";

                    }

                    new Noty({
                        layout: 'topCenter',
                        type: 'error',
                        text: this.warningUsernameEmpty,
                        timeout: 2000
                    }).show();
                }

            },
            uploadPhoto(event) {
                let this2 = this;

                // let splitFile = this.imgProfile.split('?');
                // let fileDelete = splitFile[0].split('2F');
                //
                // let desertRef = storageRef.child('usersPhotos/' + fileDelete[1]);
                //
                // desertRef.delete().then(() => {

                let file = event.target.files[0];
                let storageRef = firebase.storage().ref('/usersPhotos/' + file.name);
                let task = storageRef.put(file);

                task.on('state_changed', snapshot => {
                    snapshot.ref.getDownloadURL().then((url) => {
                        this2.imgProfile = url;
                        this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    });

                })

            },
            toHome() {
                this.$router.replace('home');

            }
        },
        computed: {
            dataProfile() {
                this.entitats = [];
                for (let i = 0; i < this.entitatsRef.length; i++) {
                    this.entitats[i] = this.entitatsRef[i].descripcio;
                }
                let this2 = this;

                firebase.auth().onAuthStateChanged(function (user) {
                    this2.uidActualUser = user.uid;
                });

                for (let i = 0; i < this.usersRef.length; i++) {
                    //troba l'usuari actual a traves del uid i el compara amb el uid de la bbdd
                    if (this.uidActualUser === this.usersRef[i]['.key']) {
                        this2.imgProfile = this.usersRef[i].imgUser;
                        this2.usernameProfile = this.usersRef[i].username;
                        this2.scoreProfile = this.usersRef[i].score;
                        this2.numberCorrectAnswers = this.usersRef[i].numberCorrectAnswers;
                        this2.numberFailedAnswers = this.usersRef[i].numberFailedAnswers;
                        this2.counterGames = this.usersRef[i].counterGames;
                        this2.selectEntitat = this.usersRef[i].entitat;
                    }
                }


                this.usersRanking = [];
                for (let i = 0; i < this.usersRef.length; i++) {

                    this.usersRanking.push(this.usersRef[i])
                }

                this.usersRanking.sort(function (a, b) {
                    if (a.score > b.score) {
                        return -1;
                    }
                    if (a.score < b.score) {
                        return 1;
                    }
                    // a must be equal to b
                    return 0;
                });


                firebase.auth().onAuthStateChanged(function (user) {
                    this2.uidActualUser = user.uid;
                });


                for (let i = 0; i < this.usersRef.length; i++) {
                    //troba l'usuari actual a traves del uid i el compara amb el uid de la bbdd
                    if (this.uidActualUser === this.usersRef[i]['.key']) {
                        //comparar els username de l'array ranking i els usuaris de la bbdd
                        for (let j = 0; j < this.usersRanking.length; j++) {
                            if (this.usersRef[i].username === this.usersRanking[j].username) {

                                this.posicioRanking = j + 1;
                            }
                        }
                    }
                }


            }
        }
    }
</script>


<style lang="scss" scoped>

    @import url('https://fonts.googleapis.com/css?family=Josefin+Sans&display=swap');


    .whiteText {
        color: white;
    }

    .textProfile {
        font-family: 'Josefin Sans', sans-serif;
        color: dimgray;
    }

    .fileContainer {
        overflow: hidden;
        position: relative;

    }

    .fileContainer [type=file] {
        cursor: inherit;
        display: block;
        font-size: 999px;
        filter: alpha(opacity=0);
        min-height: 100%;
        min-width: 100%;
        opacity: 0;
        position: absolute;
        right: 0;
        text-align: right;
        top: 0;
    }

    .cardProfile {
        border-radius: 20px;
    }

    .personalDataProfile {
        background: #F5F5F5;
        padding: 20px;
        border-radius: 10px;
    }

    .imgUserProfileClass {
        width: 60px;
        height: 60px;

    }

    .backgroundHome {
        background-image: linear-gradient(to right top, #2f89fc, #00a0ff, #00b4fd, #00c5f1, #00d3e4, #29d9df, #43dfd9, #5ae5d2, #71e6d8, #86e7dc, #98e8e1, #aae9e4);
    }

    .logoDiba {
        position: absolute;
        padding: 20px;
        width: 150px;

    }

</style>
